import { render, staticRenderFns } from "./buildingProperties.vue?vue&type=template&id=57af330c&scoped=true&"
import script from "./buildingProperties.vue?vue&type=script&lang=js&"
export * from "./buildingProperties.vue?vue&type=script&lang=js&"
import style0 from "./buildingProperties.vue?vue&type=style&index=0&id=57af330c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af330c",
  null
  
)

export default component.exports